import { MISSION1_LEVEL_IDS } from '../../content/missionObjectives';
import type { CharacterConfig } from '../../types/content';

export interface MissionScoreSummary {
  missionScore: number;
  stagesCleared: number;
  stageCount: number;
  fullClear: boolean;
}

/** Sum of best stage scores for one character across Mission 1 (missing = 0). */
export function missionScoreForCharacter(
  highScores: Record<string, number>,
  characterId: CharacterConfig['id'],
  levelIds: readonly string[] = MISSION1_LEVEL_IDS,
): MissionScoreSummary {
  let missionScore = 0;
  let stagesCleared = 0;
  for (const levelId of levelIds) {
    const score = highScores[`${levelId}:${characterId}`] ?? 0;
    if (score > 0) {
      missionScore += score;
      stagesCleared += 1;
    }
  }
  return {
    missionScore,
    stagesCleared,
    stageCount: levelIds.length,
    fullClear: stagesCleared === levelIds.length,
  };
}

/** Best single-stage score across Mission 1 for a character. */
export function bestStageForCharacter(
  highScores: Record<string, number>,
  characterId: CharacterConfig['id'],
  levelIds: readonly string[] = MISSION1_LEVEL_IDS,
): number {
  let best = 0;
  for (const levelId of levelIds) {
    best = Math.max(best, highScores[`${levelId}:${characterId}`] ?? 0);
  }
  return best;
}
